module.exports = __webpack_public_path__ + "static/media/bookatable.1387a883.jpg";